import styled from '../../../../consts/styled';
import { colors, media, spacing } from '../../../../App/ChakraTheme';

import ArticlePageUnstyled from './ArticlePageUnstyled';

const ArticlePage = styled(ArticlePageUnstyled)`
  padding: 0 ${spacing.BASE_PLUS};
  justify-content: center;
  align-items: center;
  height: calc(100vh - 50px);

  @media (max-height: 900px) {
    height: calc(100vh + 140px);
  }

  ${media.tablet`
  .hide-tablet{display:none;}
`};
  ${media.phone`
  .hide-phone{display:none;}
`};

  .content-title-container {
    padding-left: 14px;
    position: relative;
    padding-bottom: ${spacing.SMALL};

    &:before {
      content: '';
      height: 100%;
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.4);
      left: 21px;
    }
  }

  .content-title {
    padding-left: ${spacing.TINY};
    flex-shrink: 0;

    .icon {
      margin-right: ${spacing.TINY};
      flex-shrink: 0;
    }
  }

  .content-controls {
    margin-top: ${spacing.SMALL};
    margin-bottom: ${spacing.SMALL};
    flex-wrap: wrap;
    flex-shrink: 0;

    .analytics-btn {
      margin: 8px;
      white-space: nowrap;
      font-size: 12px;
      max-height: 40px;
      min-height: 40px;
      padding: 0 12px !important;
      ${media.contentToolbar`
      margin: 4px;
      `}
      ${media.contentToolbarLg`
      font-size: 11px;
      `}
      ${media.contentToolbarMid`
      font-size: 11px;
      .icon {
        margin-right: 4px;
        width: 18px !important;
        height: 18px !important;
      }
      `}
      ${media.contentToolbarIconsOnly`
      min-width: auto !important;
      min-height: auto !important;
      min-width: ${spacing.LARGE} !important;
      height: ${spacing.LARGE} !important;
      flex-shrink: 0 !important;
      justify-content: center;
      align-items: center;
      span:not(.unshare) {
        display: none;
      }
      .icon{
        margin: 0 !important;
        flex-shrink: 0;
      }
    `}
    }
  }

  .module {
    width: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: auto;
    padding-right: 15px;
    position: relative;

    &:not(:last-of-type) .module-title:after,
    .module-title.active-module:after {
      content: '';
      height: calc(100% - 44px);
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.2);
      left: 21px;
      top: 43px;
      z-index: 0;
    }
  }

  .module-title:hover {
    cursor: pointer;
  }

  .module-title {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: ${spacing.SMALL};
    position: relative;
    transition: padding-bottom 400ms;

    &:before {
      background-color: #fff;
      margin-right: 16px;
      content: attr(data-number);
      width: 42px;
      height: 42px;
      border: 1px solid rgba(213, 214, 222, 0.8);
      border-radius: 50%;
      text-align: center;
      font-weight: 300;
      font-size: 24px;
      color: rgb(213, 214, 222);
      transition: all 400ms;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      z-index: 1;
    }

    .row-cs {
      width: 100%;
      height: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .icon {
      transition: transform 400ms;
      margin-left: ${spacing.TINY};
      flex-shrink: 0;
      transform: rotate(90deg);

      path[fill] {
        fill: ${colors.darkblue};
      }
    }

    &.active-module {
      padding-bottom: ${spacing.TINY};

      .icon {
        transform: rotate(90deg) scaleX(-1);
      }

      &:before {
        border-color: rgb(18, 18, 59);
        color: rgb(18, 18, 59);
      }
    }

    &.done {
      &:before {
        color: #fff;
        background: ${colors.limegreen};
        border-color: ${colors.limegreen};
      }
    }

    &.active-module {
      &:before {
        border-color: rgb(18, 18, 59);
      }
    }
  }

  :not(json_cms_content) iframe,
  :not(json_cms_content) canvas {
    width: 100% !important;
    flex-grow: 1;
    flex-basis: 100vh !important;
    padding-right: ${spacing.TINY};
    padding-left: ${spacing.TINY};
  }

  :not(json_cms_content)
    iframe:not(.cms_content):not(.youtube_iframe):not(.embed-block),
  :not(json_cms_content) canvas {
    height: 100vh !important;
  }

  :not(json_cms_content) iframe.embed-block {
    height: 100vh;
  }

  .cms_content {
    border: none;
    overflow: hidden;
    width: 100% !important;
    -webkit-flex-basis: auto !important;
  }

  iframe:fullscreen,
  iframe:-webkit-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    padding: 0;
    overflow: scroll;
  }

  .cms_content_container {
    overflow: hidden;
    background: #fff;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 60px;
  }

  .cms_content_container:fullscreen div:first-of-type {
    display: none;
  }

  .complete-btn:hover {
    background-color: #75d640;
  }
`;

(ArticlePage as any).getRoute = (id: string = ':id') => `/article/${id}/`;

export default ArticlePage;

export { ArticlePage };
